import { ReactNode } from 'react';

import { useMediaQuery } from '@providers/MediaQueryProvider';
import { SlimArrowButton } from '@ui/components/SlimArrowButton';

import { SiteLayout } from '@features/shared/ui/SiteLayout';

import styles from './SomePlayerProfilePage.module.css';

type Props = {
  shieldAvatar: ReactNode;
  stats: ReactNode;
  actions: ReactNode;
  themeColor?: string | null;
  onBack: () => void;
  modals?: ReactNode;
};
export function SomePlayerProfilePage({
  actions,
  shieldAvatar,
  stats,
  themeColor,
  onBack,
  modals,
}: Props) {
  const isMobile = useMediaQuery() === 'mobile';

  return (
    <SiteLayout
      className={styles.layout}
      themeColor={themeColor}
      siteLogo={
        <div className={styles.siteLogoContainer}>
          <SlimArrowButton
            size={isMobile ? '28' : '32'}
            direction="left"
            onClick={onBack}
            colorPreset="currentColor"
          />
          {!isMobile && <div className={styles.pageTitle}>Личный кабинет</div>}
        </div>
      }
      centeredTitle={isMobile ? <div className={styles.pageTitle}>Личный кабинет</div> : undefined}
      actions={actions}
      backgroundPreset="plain"
    >
      <div className={styles.content}>
        <div className={styles.leftColumn}>{shieldAvatar}</div>
        <div className={styles.mainContent}>{stats}</div>
      </div>

      {modals}
    </SiteLayout>
  );
}
